// components/DeleteConfirmDialog.js
import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Typography
} from '@mui/material';
import CommonButton from '../../common/components/CommonButton';
import theme from '../../theme';

const DeleteConfirmDialog = ({ open, onClose, onConfirm, experienceTitle }) => {
    return (
        <Dialog
            open={open}
            maxWidth="xs"
            aria-labelledby="delete-dialog-title"
        >
            <DialogContent>
                <DialogContentText>
                    <Typography sx={{ fontWeight: 600, fontSize: '22px', mt: 0.5, mb: 1 }}>
                        Are you sure you want to delete the experience?
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CommonButton
                    label="No"
                    size="small"
                    background={theme.palette.background.main}
                    border={`1px solid ${theme.palette.background.light}`}
                    handleClick={onClose}
                    marginBottom="0px"
                />
                <CommonButton
                    label="Yes"
                    size="small"
                    background={theme.palette.secondary.main}
                    color={theme.palette.primary.main}
                    handleClick={onConfirm}
                    marginBottom="0px"
                />
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;